import React from "react";

import styles from "./Passion.module.css";
import { carouselData } from "../../CarouselExplorePage/carousel-data";
import { camelCaseToHumanReadable } from "../../../utils/camelCaseToHumanReadable";
import { passionNameToKey } from "../../../utils/passionNameToKey";
import classNames from "classnames";

export const Passion = (props) => {
  const { passion } = props;

  const { value, name } = passion;
  const passionKey = passionNameToKey(name);
  const imageSrc =
    carouselData[passionKey]?.slides?.[0]?.image ??
    "https://cache.marriott.com/is/image/marriotts7prod/rz-hnlkz-golf-738776123-21226?wid=516&fit=constrain";

  const passionLevel =
    value === "false" || value === "Not Interested" || value === "N"
      ? "No"
      : value === "true"
        ? "Yes"
        : camelCaseToHumanReadable(value);

  return (
    <figure
      data-testid="profile-passion"
      className={classNames(
        styles.card,
        passionLevel === "No" ? styles.notActive : "",
      )}
    >
      <img
        className={styles.image}
        src={imageSrc}
        alt={camelCaseToHumanReadable(name)}
      />
      <figcaption className={styles.caption}>
        {camelCaseToHumanReadable(name)} = {passionLevel}
      </figcaption>
    </figure>
  );
};
